<div class="header-container" style="height: 3em;">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"><img src="assets/images/corbata1.png"></a>
  </div>
  <div style="left: 135px;position: relative;font-weight: bold;font-size: 20px;color: #FFFFFF;">
    {{ user?.company }}
  </div>
</div>





<div class="header-container" style="background-color: #4395d1;
    border-radius: 2rem;height: 3em;">
  <div class="bell-wrapper" (click)="checkAndNavigate()">
    <div class="sparks-container">

      <div class="spark-wrapper" style="transform:translate(50px, 50px) rotateZ(0deg) translateX(22px);">
        <div class="spark"></div>
      </div>
      <div class="spark-wrapper" style="transform:translate(50px, 50px) rotateZ(45deg) translateX(22px);">
        <div class="spark"></div>
      </div>
      <div class="spark-wrapper" style="transform:translate(50px, 50px) rotateZ(90deg) translateX(22px);">
        <div class="spark"></div>
      </div>
      <div class="spark-wrapper" style="transform:translate(50px, 50px) rotateZ(135deg) translateX(22px);">
        <div class="spark"></div>
      </div>
      <div class="spark-wrapper" style="transform:translate(50px, 50px) rotateZ(180deg) translateX(22px);">
        <div class="spark"></div>
      </div>
      <div class="spark-wrapper" style="transform:translate(50px, 50px) rotateZ(225deg) translateX(22px);">
        <div class="spark"></div>
      </div>
      <div class="spark-wrapper" style="transform:translate(50px, 50px) rotateZ(270deg) translateX(22px);">
        <div class="spark"></div>
      </div>
      <div class="spark-wrapper" style="transform:translate(50px, 50px) rotateZ(315deg) translateX(22px);">
        <div class="spark"></div>
      </div>

    </div>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.12 120.2">
      <title>bell</title>
      <path
        d="M112.33,88.4c-.65,16.1-30.57,17.07-30.24,17.4-3.26,5.52-8.78,11.38-19.84,11.38s-18.08-5.86-21.34-11.38c.33-.33-29.59-1.3-30.24-17.4C10.67,77.5,19.13,72.63,23,71s5.2-23.41,5.2-23.41S30.69,18.64,52.39,16c0,0-2.5-12.68,9.11-13,11.61.33,9.11,13,9.11,13,21.7,2.6,24.16,31.55,24.16,31.55S96.07,69.37,100,71,112.33,77.5,112.33,88.4Z"
        style="fill:none;stroke-width:5;stroke:#15425f;"/>
    </svg>
  </div>
  
  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name"
               [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
